module.exports = __webpack_public_path__ + "img/盘查核查英文.6b4714e5.png";